import { ActivatedStepsConditionData } from './activated-steps-condition-data';
import { AttributeValueConditionData } from './attribute-value-condition-data';
import { AttributesMustBeFilledInConditionData } from './attributes-must-be-filled-in-condition-data';
import { BaseConditionData } from './base-condition-data';
import { CompletedStepsConditionData } from './completed-steps-condition-data';
import { DefaultConditionData } from './default-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';
import { LogicalExpressionConditionData } from './logical-expression-condition-data';
import { MandatoryAttributesMustBeFilledInConditionData } from './mandatory-attributes-must-be-filled-in-condition-datas';
import { StepSpecificStateConditionData } from './step-specific-state-condition-datas';

/**
 * Represente les données d'un évènement de workflow.
 */
export class EventData {
    public isEnabled: boolean;

    public conditions: BaseConditionData[];

    public id: number;

    /**
     * Constructeur.
     */
    public constructor() {}

    /**
     * Retourne une copie d'une instance de EventData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: EventData) {
        if (!!other) {
            const instance = new EventData();
            instance.isEnabled = other.isEnabled;

            instance.conditions = EventData.cloneConditionArray(other.conditions);

            instance.id = other.id;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de EventData
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: EventData[]) {
        if (!!others) {
            let eventDatas: EventData[] = [];

            others.forEach((x) => {
                const eventData = EventData.clone(x);
                eventDatas.push(eventData);
            });

            return eventDatas;
        } else {
            return [];
        }
    }

    public static cloneConditionArray(others: BaseConditionData[]) {
        if (!!others) {
            let conditions: BaseConditionData[] = [];

            others.forEach((x) => {
                const eventData = EventData.cloneCondition(x);
                conditions.push(eventData);
            });

            return conditions;
        } else {
            return [];
        }
    }

    public static cloneCondition(other: BaseConditionData): BaseConditionData {
        switch (other.type) {
            case WorkflowConditionTypes.None:
                return DefaultConditionData.clone(other as DefaultConditionData);
            case WorkflowConditionTypes.AttributeValue:
                return AttributeValueConditionData.clone(other as AttributeValueConditionData);
            case WorkflowConditionTypes.AttributesMustBeFilledIn:
                return AttributesMustBeFilledInConditionData.clone(other as AttributesMustBeFilledInConditionData);
            case WorkflowConditionTypes.LogicalExpression:
                return LogicalExpressionConditionData.clone(other as LogicalExpressionConditionData);
            case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                return MandatoryAttributesMustBeFilledInConditionData.clone(other as MandatoryAttributesMustBeFilledInConditionData);
            case WorkflowConditionTypes.StepActivated:
                return ActivatedStepsConditionData.clone(other as ActivatedStepsConditionData);
            case WorkflowConditionTypes.StepCompleted:
                return CompletedStepsConditionData.clone(other as CompletedStepsConditionData);
            case WorkflowConditionTypes.StepSpecificState:
                return StepSpecificStateConditionData.clone(other as StepSpecificStateConditionData);
            default:
                console.error(`Le type de condition '${other.type}' n'est pas implémentée.`);
                throw new Error(`Le type de condition '${other.type}' n'est pas implémentée.`);
        }
    }
}
